// Triggers a browser download for `blob` using the attached-anchor pattern.
// Safari refuses `click()` on detached `<a>` elements, so the anchor must be
// appended to the DOM before the click and removed in a `finally` to avoid
// leaking the node or the object URL if the click throws.
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  try {
    a.click();
  } finally {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
};
